import { gateway } from "../../../gateway";
import ICoverageArea from "../interfaces/ICoverageArea";

const getAuthHeader = () => {
  const token = sessionStorage.getItem("token");
  return { Authorization: token ?? "" };
};

/** Backend may return latitude, longitude, milesOfCoverageArea as strings; normalize to numbers for maps. */
function normalizeCoverageArea(raw: Record<string, unknown>): ICoverageArea {
  const lat = Number(raw.latitude);
  const lng = Number(raw.longitude);
  const miles = Number(raw.milesOfCoverageArea);
  return {
    id: raw.id as number,
    name: (raw.name as string) ?? "",
    latitude: Number.isFinite(lat) ? lat : 0,
    longitude: Number.isFinite(lng) ? lng : 0,
    milesOfCoverageArea: Math.min(20, Math.max(0, Number.isFinite(miles) ? miles : 0)), // Max 20 miles
    color: (raw.color as string) ?? "",
    address: (raw.address as string) ?? "",
    city: (raw.city as string) ?? "",
    state: (raw.state as string) ?? "",
    zipCode: raw.zipCode != null ? String(raw.zipCode) : "",
    country: (raw.country as string) ?? "",
  };
}

// GET
export const fetchMyCoverageAreasAction = async (): Promise<ICoverageArea[]> => {
  const res = await gateway.get(`coverageareas/self`, {
    headers: getAuthHeader(),
  });

  const rawList = res.data?.data ?? res.data;
  if (!Array.isArray(rawList)) return [];
  return rawList.map((item: Record<string, unknown>) => normalizeCoverageArea(item));
};

// POST
export const createCoverageAreaAction = async (dto: ICoverageArea) => {
  const res = await gateway.post(`coverageareas/self`, dto, {
    headers: getAuthHeader(),
  });
  return res.data?.data ?? res.data;
};

// PUT
export const updateCoverageAreaAction = async (dto: Partial<ICoverageArea>) => {
  const res = await gateway.put(`coverageareas/self`, dto, {
    headers: getAuthHeader(),
  });
  return res.data?.data ?? res.data;
};

// DELETE
export const deleteCoverageAreaAction = async (id: number) => {
  const res = await gateway.delete(`coverageareas/self/${id}`, {
    headers: getAuthHeader(),
  });
  return res.data;
};
